import { Box, Center, Grid, VStack } from '@chakra-ui/react';

import asBentoPage from '../../../../../../common/bento/hoc/asBentoPage';
import Accordion from '../../../../../../components/_core/Accordion';
import Button from '../../../../../../components/_core/Button';
import Heading from '../../../../../../components/_core/Heading';
import Text from '../../../../../../components/_core/Text';
import OBNavigation from '../../../../components/OBNavigation/OBNavigation';
import locales from './locales';

interface BeneficiariesSummaryProps {
  onNext: () => void;
  onSkip: () => void;
  companyName: string;
  showSkipButton: boolean;
}

const BeneficiariesSummary = asBentoPage<BeneficiariesSummaryProps>(
  ({ companyName, Layout, onNext, onPrev, onSkip, showSkipButton }) => {
    return (
      <Layout nav={<OBNavigation onPrev={onPrev} />}>
        <Heading marginBottom="space-24" size="lg">
          {locales.heading}
        </Heading>

        <Text marginBottom="space-40">
          {locales.formatString(locales.description, { companyName })}
        </Text>

        <VStack alignItems="start" marginBottom="space-40" spacing="space-32">
          {locales.steps.map((step, index) => (
            <Grid gap="space-16" key={step.title} templateColumns="40px 1fr">
              <Center
                bgColor="grey.200"
                borderRadius="radius-12"
                height="space-40"
                width="space-40"
              >
                <Text fontWeight="weight-500" size="lg">
                  {index + 1}
                </Text>
              </Center>

              <Box>
                <Text fontWeight="weight-500" variant="primary">
                  {step.title}
                </Text>
                <Text size="sm">{step.description}</Text>
              </Box>
            </Grid>
          ))}
        </VStack>

        <Accordion marginBottom="space-40">
          <Accordion.Item title={locales.accordion.title}>
            <Accordion.Text>{locales.accordion.text}</Accordion.Text>
          </Accordion.Item>
        </Accordion>

        <Button marginBottom="space-16" onClick={onNext} width="full">
          {locales.buttons.cta}
        </Button>
        {showSkipButton ? (
          <Box textAlign="center">
            <Button onClick={onSkip} variant="inline-secondary">
              {locales.buttons.skip}
            </Button>
          </Box>
        ) : null}
      </Layout>
    );
  },
);

export default BeneficiariesSummary;
